import {FC} from 'react'
import {Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {MasterInit} from '../../_metronic/layout/MasterInit'

export const AppRoutes: FC = () => {
  return (
    <>
      <Routes>
        <Route
          path='/*'
          element={
            <MasterLayout>
              <PrivateRoutes />
            </MasterLayout>
          }
        />
        <Route path='error/*' element={<ErrorsPage />} />
      </Routes>
      <MasterInit />
    </>
  )
}
